import {
  createAuthorizedGetRequest,
  fetchUnparsedApi,
  normalizePath,
  string,
  stringify,
} from '@/services/api';
import { pipe } from 'fp-ts/function';
import { chain, map } from 'fp-ts/TaskEither';
import { getToken } from '@/services/token';
import { fromIOEither } from 'fp-ts/lib/TaskEither';
import { encodeIssueQuery, IssueQuery } from '@/services/api/resources/issue/v2/query';

export type SupportedExportFormat = 'csv' | 'xlsx';

export enum SupportedExportFormatEnum {
  CSV = 'csv',
  XLSX = 'xlsx'
}

export enum SupportedFileVersionsEnum {
  SIMPLE = 'simple'
}

const baseUrl = '/v2/export/issues';

const createDownloadUrlBatch = (
  url: string,
  format: string,
  timezone: string,
  query: IssueQuery,
) => (
  token: string,
) => {
  const u = new URL(normalizePath(`${url}`));
  u.search = stringify({
    token: string(token),
    format: string(format),
    timezone: string(timezone),
    ...encodeIssueQuery(query),
    sort: '-createdAt',
  });
  return u;
};

export const issuesReportExportUrl = (
  query: IssueQuery,
  format: SupportedExportFormat,
  timezone: string,
) => pipe(
  getToken(),
  fromIOEither,
  map(createDownloadUrlBatch(`${baseUrl}`, format, timezone, query)),
);

export const issuesReportDownload = (
  url: string,
) => pipe(
  url,
  createAuthorizedGetRequest,
  chain(fetchUnparsedApi),
);
